import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Grid, Typography, Card, CardMedia, CardContent, Container, Paper, useTheme } from "@mui/material";
import { motion } from "framer-motion";
// import { useTheme } from "@mui/material/styles";
import { Link } from 'react-router-dom';
const projects = [
  {
    icon: "🏡",
    title: "Modern Facades & Smart Layouts ",
    desc: "Modern, high-quality homes tailored to your lifestyle.",
  },
  {
    icon: "🔨",
    title: "Open-plan Living Spaces",
    desc: "Replace your old home with a fresh, custom-built design.",
  },
  {
    icon: "🧱",
    title: "Custom Features Based on Client Vision",
    desc: "Unique homes designed around your needs and vision.",
  },

];
export default function Section_6() {
  const [cards, setCards] = useState([]);
  const theme = useTheme(); // Access Material UI theme for responsive styles

  useEffect(() => {
    const fetchProjectCards = async () => {
      try {
        const response = await axios.get("https://urbancasabackendfiles.onrender.com/api/project-cards/all");
        setCards(response.data);
      } catch (error) {
        console.error("Error fetching project cards:", error);
      }
    };
    fetchProjectCards();
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "black",
        backgroundImage: `url(/assets/section-6-main-bg-img.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        py: { xs: 2, md: 8 }, // Adjust padding for responsiveness
        px: { xs: 0, md: 0 },
      }}
    >
      {/* Heading Section */}
      {/* <Box sx={{ textAlign: "center", mb: 4 ,display: "flex", justifyContent: "center", alignItems: "center", flexDirection:"column",gap: 4}}>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 2 }}>
          <img src="/assets/section-3-head-img.png" alt="Heading Icon" style={{ width: 50 }} />
          <Typography variant="h4" sx={{ color: "white", fontWeight: "bold" }}>
            Our Projects
          </Typography>
        </Box>
        <Typography
          sx={{
            maxWidth: "600px",
            mx: "auto",
            fontSize: { xs: "4vw", md: "1.5vw" },
            fontWeight: 500,
            textAlign: "center",
            background: "linear-gradient(to bottom, #FFFFFF, #404040)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, quasi.
        </Typography>
      </Box> */}


      {/* Heading Section */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={4} >
          {/* Left Side - Heading */}
          <Grid item xs={12} md={4}>
            <Box display="flex" alignItems="center" gap={2} mb={2}>
              <img
                src="/assets/section-3-head-img.png"
                alt="heading-icon"
                style={{ width: "50px", height: "50px" }}
              />
              <Typography
                variant="h3"
                sx={{
                  color: "white",
                  fontSize: { xs: "2rem", sm: "2.5rem", md: "2.8rem" },
                  fontWeight: 700,
                }}
              >
                Our Projects
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "white",
                opacity: 0.8,
                fontSize: { xs: "1rem", md: "1.1rem" },
                textAlign:"justify"
              }}
            >
              At Urban Casa, every project tells a story — of vision, design, and transformation. We take pride in delivering beautifully crafted homes that reflect our commitment to quality, innovation, and modern living.Whether it’s a contemporary family home in the suburbs or a sleek duplex in an urban setting, Urban Casa projects stand as a benchmark for style, practicality, and long-lasting value.

            </Typography>
            <Typography
              sx={{
                color: "white",
                opacity: 0.8,
                fontSize: { xs: "1rem", md: "1.1rem" },
              }}
            >
              From single-family homes to custom builds and multi-unit developments, our portfolio showcases a diverse range of designs tailored to different lifestyles and budgets. Each project is completed with a sharp focus on detail, efficiency, and client satisfaction.
              Explore our completed builds and ongoing developments below — and imagine what we can create for you.               </Typography>
          </Grid>

          {/* Right Side - Services */}
          <Grid item xs={12} md={8} >
            <h1 className="projects-container-projects-details-bullets-details-main-heading text-white text-center text-2xl mb-12">✦ What You’ll See in Our Projects:
            </h1>
            <Grid container spacing={3} alignItems="center" justifyContent="center">

              {projects.map((project, index) => (

                <Grid item xs={12} sm={6} key={index}>
                  <motion.div
                    whileHover={{ scale: 1.03 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Paper
                      elevation={4}
                      sx={{
                        p: 3,
                        backgroundColor: "#1c1c1c",
                        borderRadius: "16px",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        color: "white",
                        border: "1px solid #333",
                        transition: "0.3s ease",
                        "&:hover": {
                          backgroundColor: "#272727",
                        },
                      }}
                    >
                      <Typography variant="h5" gutterBottom>
                        {project.icon} {project.title}
                      </Typography>
                      <Typography variant="body1" sx={{ opacity: 0.85 }}>
                        {project.desc}
                      </Typography>
                    </Paper>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>






      {/* Project Cards Section */}
      <Grid container spacing={12} justifyContent="center">
        {cards.length > 0 ? (
          cards.map((card, index) => (
<Link to="/custom-homes">
            
            <Grid item xs={10} sm={6} md={4} key={index}>
              <Card
                sx={{
                  bgcolor: "rgba(0,0,0,0.8)",
                  borderRadius: "12px",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": { transform: "scale(1.05)" },
                  overflow: "hidden",
                  width: {xs:"80vw",lg:"35vw"}
                }}
              >
                <CardMedia component="img" height="200" image={card.imageUrl} alt="Project Image" />
                <CardContent>
                  <Typography variant="h6" sx={{ color: "white", fontWeight: "bold" }}>
                    {card.title}
                  </Typography>
                  <Typography sx={{ color: "white", opacity: 0.8 }}>{card.description}</Typography>
                </CardContent>
              </Card>
            </Grid>
        </Link>
          ))
        ) : (
          <Typography sx={{ color: "white", textAlign: "center", width: "100%", mt: 4 }}>Loading projects...</Typography>
        )}
      </Grid>
    </Box>
  );
}
